import _ from 'underscore';

export const validateNumeric = (value) => {
  const regex = /^[0-9]+$/;
  return String(value).match(regex);
};

export const validateDecimal = (value) => {
  const regex = /^\d{0,12}(\.\d{1,4})?$/;
  return String(value).match(regex);
};

export const validateProtocol = (value) => {
  const regex = /^http(s)?:\/\//;
  return value && value.toLowerCase().trim().match(regex);
};

export const validateString = value => (_.isString(value) && !(/<[^>]*>/).exec(value));

const timeRangeSchema = {
  day: {
    lowerBound: 0,
    upperBound: 90, // upper bound for conversion window
  },
  hour: {
    lowerBound: 0,
    upperBound: 23,
  },
  min: {
    lowerBound: 0,
    upperBound: 59,
  },
  sec: {
    lowerBound: 0,
    upperBound: 59,
  },
};

export const validateRange = (timeKey, timeValue) => {
  const { lowerBound, upperBound } = timeRangeSchema[timeKey];

  return timeValue >= lowerBound && timeValue <= upperBound;
};

export const validateRangeObj = (timeObj) => {
  let validationResult = true;
  _.each(Object.keys(timeObj), (timeKey) => {
    const isValid = validateRange(timeKey, timeObj[timeKey]);
    if (!isValid) {
      validationResult = false;
    }
  });
  return validationResult;
};

export const validateSpecificView = (goalObject) => {
  const goalType = goalObject.Type;
  switch (goalType) {
    case 'DestinationGoal':
      return goalObject.Operator && goalObject.UrlString && ((goalObject.Operator !== 'EqualsTo' && goalObject.Operator !== 'BeginsWith') || validateProtocol(goalObject.UrlString));
    case 'ApplicationInstallGoal':
      return !!goalObject.ApplicationStoreId;
    case 'PageViewsPerVisitGoal':
      return !_.isUndefined(goalObject.PageViews) && goalObject.PageViews <= 9999;
    case 'DurationGoal':
      return !_.isUndefined(goalObject.Duration);
    case 'EventGoal': {
      let isStringValid = true;
      if (goalObject.Category) {
        isStringValid = isStringValid && validateString(goalObject.Category);
      }
      if (goalObject.Action) {
        isStringValid = isStringValid && validateString(goalObject.Action);
      }
      if (goalObject.Label) {
        isStringValid = isStringValid && validateString(goalObject.Label);
      }
      return isStringValid && (!!goalObject.Category || !!goalObject.Action || !!goalObject.Label || !!goalObject.Value);
    }
    default:
      return true;
  }
};
